import { IAuthErrors } from './types';

export const validateAuthForm = (
  email: string,
  password: string,
  termsAndConditions: boolean
) => {
  const errors: IAuthErrors = {
    email: validateEmail(email),
    password: validatePassword(password),
    termsAndConditions: validateTermsAndConditions(termsAndConditions),
  };

  return errors;
};

const validEmailRegex =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;

const validateEmail = (email: string) => {
  const errors: IAuthErrors['email'] = {
    invalid: false,
    message: '',
  };

  if (!email || validEmailRegex.test(email) === false) {
    errors.invalid = true;
    errors.message = 'Please enter a valid email address';
  }

  return errors;
};

const validatePassword = (password: string) => {
  const errors: IAuthErrors['password'] = {
    invalid: false,
    message: '',
  };

  if (!password) {
    errors.invalid = true;
    errors.message = 'Password is required';
  }

  return errors;
};

const validateTermsAndConditions = (termsAndConditions: boolean) => {
  const errors: IAuthErrors['termsAndConditions'] = {
    invalid: false,
    message: '',
  };

  if (!termsAndConditions) {
    errors.invalid = true;
    errors.message = 'You must accept the Terms of Use';
  }

  return errors;
};
